// project import
import Navigation from './Navigation';

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = ({ organizationName }) => <Navigation organizationName={organizationName} />;

export default DrawerContent;
